import { StrategicalClassesType } from '../../enum/fixedincome/strategical-classes-type.enum';
import { PROFITABILITY_INDEXER } from "./profitability-indexers.constants";

export const STRATEGICAL_CLASSES_INDEXERS = {
    [PROFITABILITY_INDEXER.Selic]: StrategicalClassesType.PosFixed,
    [PROFITABILITY_INDEXER.Cdi]: StrategicalClassesType.PosFixed,
    [PROFITABILITY_INDEXER.CdiPlus]: StrategicalClassesType.PosFixed,
    [PROFITABILITY_INDEXER.Ipca]: StrategicalClassesType.LinkedToInflation,
    [PROFITABILITY_INDEXER.Igpm]: StrategicalClassesType.LinkedToInflation,
    [PROFITABILITY_INDEXER.Pre]: StrategicalClassesType.PreFixed,
};